module.exports = __webpack_public_path__ + "bd5985e1ef1b66fff5ee7ea34d07fd2e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/saxophone-s.png
// module id = 2726
// module chunks = 0